import config from '../config';
import MPUtils from '../utils/MPUtils';

let soundManager;
let dataManager;

class Intro extends Phaser.Scene {
  init () {
    // console.log('Intro.init');
    let g = this;
    soundManager = g.scene.get('SoundManager');
    soundManager.playMusic('loop-intro');

    dataManager = g.sys.game.dataManager;
    dataManager.setSessionItem(config.BASE_SCENE, 'Intro');

    this.viewport = new Phaser.Structs.Size(this.scale.width, this.scale.height, this.game.scale.scaleMode);
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
  }
  create () {
    // console.log('Intro.create');
    let g = this;

    g.events.off('resume');
    g.events.on('resume', (a, data) => {
      // console.log('On Intro Resume');
      soundManager.resumeMusic();
    });

    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'intro-bg');

    this.logo = g.add.sprite(config.CENTER_X, config.CENTER_Y - 300, 'logo');

    var brandLogoX = config.CENTER_X;
    var brandLogoY = this.logo.y - (this.logo.height * 0.5);

    this.brandLogo = g.add.sprite(brandLogoX, brandLogoY, 'brandLogo');
    this.brandLogo.setScale(0.6);
    this.brandLogo.setOrigin(0.5, 0);

    if(g.game.deviceManager.mobile && (this.brandLogo.y < (config.CENTER_Y - (this.viewport.height * 0.5)))){
      this.brandLogo.x = Math.max(70, config.CENTER_X - (this.logo.width * 0.5));
      this.brandLogo.y = config.CENTER_Y - (this.viewport.height * 0.5) + 10;
    }

    this.settingsBtn = g.add.sprite(config.WIDTH - 60, config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60, 'common');
    this.settingsBtn.setFrame('gear-icon-a.png');
    this.settingsBtn.setInteractive();
    this.settingsBtn.on('pointerdown', () => {
      g.scene.launch('Settings');
    });

    let grizzPacking = g.add.sprite(config.CENTER_X + 26, config.CENTER_Y, 'intro-packing');
    grizzPacking.setVisible(false);
    // grizzPacking.setFrame('intro-packing_26.png');
    let grizz = g.add.sprite(config.CENTER_X + 46, config.CENTER_Y + 59, 'intro-grizz');
    grizz.setFrame('grizz_00.png');

    let pandaPacking = g.add.sprite(config.CENTER_X + 125, config.CENTER_Y + 100, 'intro-packing');
    pandaPacking.setVisible(false);
    // pandaPacking.setFrame('intro-packing_26.png');
    let panda = g.add.sprite(config.CENTER_X + 26, config.CENTER_Y + 54, 'intro-panda');
    panda.setFrame('panda_11.png');

    let icePacking = g.add.sprite(config.CENTER_X - 100, config.CENTER_Y + 200, 'intro-packing');
    // icePacking.setFrame('intro-packing_26.png');
    icePacking.setVisible(false);
    let ice = g.add.sprite(config.CENTER_X - 27, config.CENTER_Y + 36, 'intro-ice');
    ice.setFrame('ice_25.png');

    g.time.delayedCall(400, () => {
      grizz.play('intro-grizz-animate');
      grizzPacking.play('intro-packing-animate');
    });
    g.time.delayedCall(600, () => {
      panda.play('intro-panda-animate');
      pandaPacking.play('intro-packing-animate');
    });
    g.time.delayedCall(800, () => {
      ice.play('intro-ice-animate');
      icePacking.play('intro-packing-animate');
    });

    let playBtn = g.add.sprite(config.CENTER_X, config.CENTER_Y + 200, 'common');
    playBtn.setFrame('play-icon-a.png');
    playBtn.setInteractive();
    playBtn.on('pointerdown', () => {
      soundManager.playSound('play-button');
      g.scene.start('Play', { fixedHighScore: false, replayLevel: false, isNewGame: false });
    });

    // TODO: Hook up best score logic
    let bestScore = dataManager.getHighScore();
    if (bestScore > 0) {
      let tape = g.add.sprite(config.CENTER_X, config.CENTER_Y + 375, 'intro-tape');
      tape.play('intro-tape-animate');
      let bestText = g.add.text(config.CENTER_X, tape.y - 35, g.sys.game.localisationManager.GetString("best"), { fontFamily: '"FredBurger Black"', fontSize: 40 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
      MPUtils.ClampTextToDimensions(bestText, 375, 200);
      bestText.setAlpha(0);
      let bestScoreText = g.add.text(bestText.x, bestText.y + 65, bestScore.toLocaleString(), { fontFamily: '"FredBurger Black"', fontSize: 69 +"px", color: "#db433e" }).setOrigin(0.5).setStroke('#000', 3);
      MPUtils.ClampTextToDimensions(bestScoreText, 550, 200);

      bestScoreText.setOrigin(0.5);
      bestScoreText.setAlpha(0);
      g.tweens.add({
        targets: [bestText, bestScoreText],
        alpha: 1,
        duration: 250
      });
      soundManager.playSound('tape');
      g.time.delayedCall(300, () => {
        soundManager.playSound('tape');
      });
    }

    this.cnLogo = g.add.sprite(10, config.CENTER_Y + (this.viewport.height * 0.5) - 10, 'cnLogo');
    this.cnLogo.setOrigin(0, 1);

    this.scale.on("resize", this.OnResize, this);

    // temp launch settings screen
    // g.time.delayedCall(100, () => {
    //   g.scene.launch('Settings');
    // });
  }

  OnResize(){
    this.viewport.setAspectRatio(this.scale.parentSize.aspectRatio);
    this.settingsBtn.y = config.CENTER_Y - (Math.min(this.viewport.height, this.scale.height) * 0.5) + 60;
    this.cnLogo.y = config.CENTER_Y + (this.viewport.height * 0.5) - 10;

    this.brandLogo.x = config.CENTER_X;
    this.brandLogo.y = this.logo.y - (this.logo.height * 0.5);

    if(this.game.deviceManager.mobile && (this.brandLogo.y < (config.CENTER_Y - (this.viewport.height * 0.5)))){
      this.brandLogo.x = Math.max(70, config.CENTER_X - (this.logo.width * 0.5));
      this.brandLogo.y = config.CENTER_Y - (this.viewport.height * 0.5) + 10;
    }
  }
}

export default Intro;
